import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/delta/h5/');
const App: React.FunctionComponent = (props) => {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_new');

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic name={['DELTA_M_1.webp', 'DELTA_M_1.png']} alt={t('second_ac_output_value')} aria-label={t('second_ac_output_value')} />
                        <span className="text">{t('second_ac_output_value')}</span>
                        <span className="text">{t('second_ac_output')}</span>
                    </div>
                    <div className="view-item view-item-2">
                        <EFPic name={['DELTA_M_2.webp', 'DELTA_M_2.png']} alt={t('second_bms')} aria-label={t('second_bms')} />
                        <span className="text">{t('second_bms')}</span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic name={['DELTA_M_3.webp', 'DELTA_M_3.png']} alt={t('second_ac_fast_input')} aria-label={t('second_ac_fast_input')} />
                        <span className="text">{t('inputTime')}</span>
                        <span className="text">{t('second_ac_fast_input')}</span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic
                            name={['DELTA_M_4.webp', 'DELTA_M_4.png']}
                            alt={t('second_solar_charging_value')}
                            aria-label={t('second_solar_charging_value')}
                        />
                        <span className="text">{t('second_solar_charging_value')}</span>
                        <span className="text">{t('second_solar_charging')}</span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic name={['DELTA_M_6.webp', 'DELTA_M_6.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <span className="text">
                            {t.rich('second_capacity', {
                                brMark: (child: string) => <span className="second_capacity_br">{child}</span>,
                            })}
                        </span>
                    </div>
                    {/* <div className="view-item view-item-5">
                        <EFPic name={['DELTA_M_5.webp', 'DELTA_M_5.png']} alt={t('second_capacity')} aria-label={t('second_capacity')} />
                        <span className="text">{t('second_eps')}</span>
                    </div> */}
                </article>
            </section>
        </>
    );
};

export default App;
